@if (pendingLoad > 0) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <div class="plans-wrapper">
    @if (shouldShowSplitBillingPaymentMethodBanner) {
      <pdq-banner
        class="split-billing-pm-banner"
        variant="attention"
        bannerTitle="A payment method is required for Split billing plans"
        content="Please add a payment method first, then come back here to choose your plan."
        button="Add payment method"
        variantButton="primary"
        [buttonLoading]="isOpeningPaymentSetup"
        [closable]="false"
        (onButtonClick)="onAddPaymentMethodFromBanner()"></pdq-banner>
    }
    <article class="header-article">
      <div class="header-text">
        <span class="title">Our Plans</span>
      </div>
    </article>
    <div class="table-wrapper">
      <table class="plans-table">
        <thead>
          <th [width]="100 / (displayedPlanTemplates?.length + 1) + '%'">
            <span class="center-items">
              <pdq-icon icon="store_icon" size="x-large" class="store-icon"></pdq-icon>
            </span>
          </th>
          @for (plan of displayedPlanTemplates; track plan) {
            <th [width]="100 / (displayedPlanTemplates?.length + 1) + '%'">
              <span class="plan-name">{{ plan.name }}</span>
              <span class="title price">
                <span class="medium">{{ currencySymbol }}</span>
                <span class="xlarge">{{
                  plan.calculatedPrice === 0 ? (plan.usagePrice | number) : (plan.calculatedPrice | number)
                }}</span>
                <span class="medium">/{{ plan.calculatedPrice === 0 ? 'order' : plan.displayedPeriod }} </span>
              </span>
              <pdq-button
                class="centered-button"
                [variant]="getPlanBtnVariant(plan)"
                [label]="getPlanBtnTxt(plan)"
                [disabled]="plan.id === currPlan?.planTemplate?.id || isPlanBlockedOnPaymentMethod(plan)"
                [matTooltip]="
                  isPlanBlockedOnPaymentMethod(plan) ? 'Add a payment method first to choose this plan' : null
                "
                matTooltipPosition="above"
                matTooltipClass="pdq-mat-tooltip"
                [icon]="plan.id === currPlan?.planTemplate?.id ? 'v_icon' : undefined"
                (click)="onPlanSelected(plan)"
                [loading]="plan.isLoading">
              </pdq-button>
            </th>
          }
        </thead>
        @for (prop of tableFields; track prop) {
          <tr>
            <td class="field-description">
              <div class="flex-row space-between">
                <div class="flex-column">
                  <span>{{ prop.displayedName }}</span>
                  <span class="additional-info">{{ prop.fieldMoreInfo }}</span>
                </div>
                @if (prop.tooltip) {
                  <pdq-icon
                    class="icon"
                    icon="more_information"
                    [matTooltip]="prop.tooltip"
                    matTooltipPosition="left"
                    matTooltipClass="pdq-mat-tooltip"></pdq-icon>
                }
              </div>
            </td>
            @for (plan of displayedPlanTemplates; track plan) {
              <td class="cell">
                @if (prop.icon && prop.icon(plan[prop.propName], plan) !== 'false') {
                  <pdq-icon
                    class="value-icon"
                    [icon]="prop.icon(prop.value !== undefined ? prop.value : plan[prop.propName], plan)"></pdq-icon>
                } @else {
                  <span>{{ prop.value !== undefined ? prop.value : plan[prop.propName] }}</span>
                  @if (prop.valueMoreInfo) {
                    <span class="additional-info" [innerHtml]="prop.valueMoreInfo(plan[prop.propName])"></span>
                  }
                }
              </td>
            }
          </tr>
        }
      </table>
    </div>
    <div class="generic-details">
      <span class="title">All plans include</span>
      <span class="generic-details__list">
        @for (item of commonItemsToDisplay; track item) {
          <span class="generic-details__list__item">
            <pdq-icon icon="blue_v" size="large"></pdq-icon>
            <span>
              {{ item.text }}
              @if (item.additionalInfo) {
                <span class="additional-info"> {{ item.additionalInfo }} </span>
              }
            </span>
          </span>
        }
      </span>
    </div>
    <ng-template #contact>
      <article class="header-article">
        <div class="header-text">
          <span class="title">Contact us for pricing</span>
          <span>Reach out to your account manager for custom pricing</span>
        </div>
      </article>
    </ng-template>
  </div>
}
